// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "recommendations-" + chunkId + ".js?v=" + {"node_modules_nextcloud_vue_dist_Components_NcColorPicker_mjs":"caf737663f3168c31999","node_modules_nextcloud_vue_dist_Components_NcSelect_mjs":"5bc1590fd99de766f25d","vendors-node_modules_rehype-highlight_index_js":"70a4778e6219bb956045"}[chunkId] + "";
};